import * as React from "react";

import { useState } from "react";

import "../../pages/ScrollB.css";
// import "./CustomerIventroyTransaction.css";
import VendorBillsTransactions from "./VendorBillsTransactions";
// import VendorTSelect from "./VendorTSelect";
import VendorPayment from "./VendorPayment";
import VendorPurchaseOrder from "./VendorPurchaseOrder";
// import VendorTPR from "./CustomerInventoryItems/VendorTPR.JSX";
import VendorLedgerTab from "./VendorLedgerTab";
// import VendorTPR from "./CustomerInventoryItems/VendorTPRV.jsx";
import VendorTPRV from "./VendorPurchaseReceives.jsx";

function VendorTransaction(props) {
  const [toggleState, setToggleState] = useState(1);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  const tabs = [
    { id: 1, name: "Bills" },
    { id: 2, name: "Bill Payments" },
    { id: 3, name: "Purchase Orders" },
    { id: 4, name: "Purchase Receives" },
    { id: 5, name: "Vendor Ledger" },
  ];
  // { id: 5, name: "Vendor Credits" },

  return (
    <>
      <div className="container">
        <div className="content-tabs">
          {/* Tailwind Tabs */}
          <div className="w-full border-b border-gray-200 mb-4 px-4">
            <nav className="-mb-px flex space-x-6" aria-label="Tabs">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => toggleTab(tab.id)}
                  className={`
                    whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-all duration-200
                    ${
                      toggleState === tab.id
                        ? "border-buttonColor text-buttonColor"
                        : "border-transparent text-filterTextColor hover:text-gray-700 hover:border-gray-300"
                    }
                  `}
                >
                  {tab.name}
                </button>
              ))}
            </nav>
          </div>

          <div className="px-4">
            {toggleState === 1 && (
              <VendorBillsTransactions vendor_id={props.vendor_id} />
            )}
            {toggleState === 2 && (
              <VendorPayment vendor_id={props.vendor_id} />
            )}
            {toggleState === 3 && (
              <VendorPurchaseOrder vendor_id={props.vendor_id} />
            )}
            {toggleState === 4 && (
              <VendorTPRV vendor_id={props.vendor_id} />
            )}
            {toggleState === 5 && (
              <VendorLedgerTab vendor_id={props.vendor_id} />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default VendorTransaction;
